import { v1ApiClient } from '@/services';
import type {
  PathParams,
  RequestBody,
  ResponseBody,
} from '@/shared/api/generated';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

type CreateNotificationPath = '/v1/workspaces/{workspace_id}/notifications';

type CreateNotificationParams = Partial<
  PathParams<CreateNotificationPath, 'post'>
> &
  RequestBody<CreateNotificationPath, 'post'>;
type CreateNotificationResponse = ResponseBody<CreateNotificationPath, 'post'>;

/**
 * 알림 생성
 */
export const createNotification = ({
  workspace_id,
  ...body
}: CreateNotificationParams): Promise<CreateNotificationResponse> => {
  const wa = workspace_id ?? getCurrWorkspaceAlias();
  return v1ApiClient
    .post(`/workspaces/${wa}/notifications`, body)
    .then((res) => res.data);
};
